import { Box, Divider, Stack, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";
import { Fragment } from "react";

const styles = {
  container: {
    display: "flex",
    backgroundColor: "#EFF5F7 !important",
    boxSizing: "border-box !important",
    borderRadius: "8px",
    width: "100%",
    height: "165px",
    transition: "all 0.2s ease",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containerCicle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "180%",
    color: "white",
    transition: "all 0.2s ease",
    boxSizing: "border-box !important",
  },
};

const CheckCustom = () => (
  <Check
    sx={{
      mt: 1,
      fontSize: {
        xs: "20px",
        sm: "25px",
        md: "30px",
      },
    }}
  />
);

const DividerCustom = () => (
  <Box
    width="100%"
    mb={{ xs: "22.5px", sm: "32px", md: "38px" }}
    ml={{ xs: "8px", sm: "16px" }}
    mr={{ xs: "8px", sm: "16px" }}
  >
    <Divider
      orientation="horizontal"
      sx={{
        width: "100%",
        boxSizing: "border-box !important",
      }}
    />
  </Box>
);

/**
 * Componente para renderizar as etapas do formulario.
 * @param {Object} props - As propriedades do componente.
 * @param {Array<{title: string}>} stepData - Array de objetos contendo o título de cada etapa.
 * @param {number} currentStep - O índice da etapa atual.
 */
export default function StepperCustom(props) {
  const { stepData, currentStep } = props;
  return (
    <Box
      sx={styles.container}
      padding={{ xs: "32px 10px", sm: "32px 20px", md: "32px 32px" }}
    >
      {stepData.map((data, index) => {
        return (
          <Fragment key={index}>
            <Stack direction={"row"} alignItems={"center"}>
              <Stack gap={"8px"} alignItems={"center"}>
                <Box
                  sx={{
                    ...styles.containerCicle,
                    border: {
                      xs: "6px solid #D3E3EB",
                      sm: "6px solid #D3E3EB",
                      md: "8px solid #D3E3EB",
                    },
                  }}
                  bgcolor={
                    index === currentStep
                      ? "#1E729F !important"
                      : "#7AABC5 !important"
                  }
                  width={{ xs: "48px", sm: "56px", md: "64px" }}
                  height={{ xs: "48px", sm: "56px", md: "64px" }}
                >
                  <Typography
                    fontSize={{ xs: "16px", sm: "20px" }}
                    fontWeight={600}
                  >
                    {index >= currentStep ? index + 1 : <CheckCustom />}
                  </Typography>
                </Box>
                <Typography
                  fontSize={{ xs: "11px", sm: "16px", md: "20px" }}
                  fontWeight={600}
                  fontFamily="Nunito"
                  color="#333333"
                >
                  {data.title}
                </Typography>
              </Stack>
            </Stack>
            {!(index === stepData.length - 1) && <DividerCustom />}
          </Fragment>
        );
      })}
    </Box>
  );
}
